import { useEffect, useState } from "react"
import { getTheme, injectTheme } from "styled-system/themes"
import { type Partner } from "../constants/partner"

/**
 * Loads and injects the Panda CSS theme for a partner.
 * @see https://panda-css.com/docs/guides/multiple-themes
 */
export function usePartnerTheme(partner: Partner | null) {
    const [isThemeReady, setIsThemeReady] = useState(!partner)

    useEffect(() => {
        if (!partner) {
            setIsThemeReady(true)
            delete document.documentElement.dataset.pandaTheme

            return
        }

        setIsThemeReady(false)

        let styleSheet: HTMLStyleElement | null = null

        void getTheme(partner).then((theme: unknown) => {
            styleSheet = injectTheme(document.documentElement, theme)
            setIsThemeReady(true)
        })

        return () => {
            delete document.documentElement.dataset.pandaTheme
            styleSheet?.remove()
        }
    }, [partner])

    return { isThemeReady }
}
